/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DoctorSavePersonalAddressRequest = {
  properties: {
    address: {
      type: 'AddressInfo',
      isRequired: true,
    },
  },
} as const;
